import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy,
  NgZone,
  ElementRef
} from '@angular/core';
import {Widget} from "../../../widgets/decorator/widget.decorator";
import {IdynamicFormItem} from "../../../../app/shared/dynamic-form/interfaces/IdynamicFormItem";
import {get, set, cloneDeep, pickBy, merge, isEmpty} from 'lodash';
import {
  IClinicalTrendsConfig, IClinicalTrendsGraphConfig,
  IClinicalTrendsListConfig, IClinicalTrendType
} from "@ispm-client/modules/clinical-dashboard/interfaces/clinica-trends.interface";
import {AgregationService} from "@ispm-client/modules/aggregator/services";
import {Subject} from "rxjs";
import {ClinicalDashboardService} from "@ispm-client/modules/clinical-dashboard/services/clinical-dashboard.service";
import {CORE_ACTIONS} from "@ispm/core/constants/core-actions.constant";
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";

@Component({
  selector: 'ispm-clinical-trends-wrapper',
  templateUrl: './clinical-trends.component.html',
  styleUrls: ['./clinical-trends.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ClinicalTrends')
export class ClinicalTrendsComponent implements OnInit, OnDestroy {

  public payload: IClinicalTrendsConfig;
  public listConfig: IClinicalTrendsListConfig;
  public graphConfig: IClinicalTrendsGraphConfig;
  public filterAvailable: boolean;
  @Input() public groupTypes: Array<IClinicalTrendType>;
  @Input() selectedItems: any;
  selectedTimeFrame: Date[];
  private listEl;
  private contentEl;
  showListPanel: boolean = true;
  private destroyed$: Subject<any> = new Subject();

  constructor(private _agregationService: AgregationService,
              private el: ElementRef,
              private _ngZone: NgZone,
              private _clinicalDashboardService: ClinicalDashboardService,
              private _store: Store<IgenomicsState>) {
  }

  ngOnInit(): void {
    this._clinicalDashboardService.getFilterStore()
      .takeUntil(this.destroyed$.asObservable())
      .map(filterData => get(filterData, 'dates'))
      .subscribe(dates => {
      this.onTrendItemsSelectionFilter(dates, true);
    });
  }

  /**
   * set clinical trends widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.payload = get(_itemConfig, 'widgetPayload');
    if (this.payload) {
      this.listConfig = get(this.payload, 'list');
      this.graphConfig = get(this.payload, 'graph');
      this.groupTypes = cloneDeep(get(this.payload, 'types'));
      this.filterAvailable = get(this.payload, 'filterAvailable', false);
      let selectedClinicalDashboard = sessionStorage.getItem("selectedClinicalDashboard").replace(" ", "").toLowerCase();
      let selectedIndexTemp = parseInt(sessionStorage.getItem('filter' + selectedClinicalDashboard));
      if (!selectedIndexTemp && selectedIndexTemp != 0) {
        this._clinicalDashboardService.updateFilterStore(get(this.payload, 'filter.defaultSelection', 'all'));
      }
    }

    this.getGraphDataMergeWithTypes();
  }

  /**
   * set clinical trends widget data
   * @param widgetData
   */
  set widgetData(widgetData: any) {

  }

  /**
   * Get each type graph data by registering to aggregator
   */
  private getGraphDataMergeWithTypes() {
    this._store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: true
    });
    let dataBindings = this.groupTypes.map(groupType => get(groupType, 'dataBinding'));
    dataBindings = dataBindings.filter(dataBinding => dataBinding);
    this._clinicalDashboardService.getTrendsData(dataBindings)
    // this._agregationService.ondemandRegister(dataBindings)
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(data => {
      if (data && Array.isArray(data)) {
        for (let index = 0; index < data.length; index++) {
          let mapData = get(data, `[${index}].response.entry`, []);
          mapData = mapData.map(item => item['resource']);
          let groupType = get(this.groupTypes, `[${index}]`);
          if (get(groupType, 'isNestedStructure') && mapData && mapData.length > 0) {
            let tempMapData = [];
            for (let tempItem of mapData) {
              let tempItemKeys = Object.keys(tempItem);
              if (tempItemKeys && tempItemKeys.length > 0) {
                for (let itemKey of tempItemKeys) {
                  if (get(groupType, 'includeParams').includes(itemKey)) {
                    let tempObj = tempItem[itemKey];
                    if (get(groupType, 'commonParams')) {
                      let commonParams = pickBy(tempItem, (value, key) => get(groupType, 'commonParams').includes(key));
                      tempObj = merge(tempObj, commonParams);
                    }
                    let labelParamsMapping = get(groupType, 'labelParams');
                    if (!isEmpty(labelParamsMapping)) {
                      tempObj = merge(tempObj, get(labelParamsMapping, itemKey));
                    }
                    tempMapData.push(tempObj)
                  }
                }
              }
            }
            set(groupType, 'data', tempMapData);
          } else {
            set(groupType, 'data', mapData);
          }


          this.groupTypes.splice(index, 1, groupType);
        }
        this.groupTypes = cloneDeep(this.groupTypes);
        if (this.selectedTimeFrame && this.selectedTimeFrame.length == 2) {
          this.onTrendItemsSelectionFilter(this.selectedTimeFrame, true);
        } else {
          this._clinicalDashboardService.updateGroupsStore(cloneDeep(this.groupTypes));
        }
      }
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
    });
  }

  /**
   * On selection of trend lines
   * @param selectedData
   * @param isTimeFrame
   */
  public onTrendItemsSelectionFilter(selectedData, isTimeFrame) {
    if (selectedData && !isTimeFrame) {
      this.selectedItems = get(selectedData, 'selectedItems');
    }
    if (isTimeFrame) {
      this.selectedTimeFrame = selectedData;
    }
    this._clinicalDashboardService.filterGroupsAndStore(cloneDeep(this.groupTypes), this.selectedTimeFrame, this.selectedItems)
  }

  /**
   * Toggle right panel
   * @param showPanel
   */
  changeTogglePanel(showPanel: boolean) {
    this._ngZone.runOutsideAngular(() => {
      this.listEl = this.listEl ? this.listEl : this.el.nativeElement.querySelector('ispm-clinical-trends-list');
      this.contentEl = this.contentEl ? this.contentEl : this.el.nativeElement.querySelector('.trends-content-wrapper');
      setTimeout(() => {
        this.showListPanel = showPanel;
        if (this.showListPanel) {
          this.listEl.style.width = '20%';
          if (this.contentEl) {
            this.contentEl.style.width = 'calc(80% - 0.5em)';
          }
        } else {
          this.listEl.style.width = '4em';
          if (this.contentEl) {
            this.contentEl.style.width = 'calc(100% - 5em)';
          }
        }
      }, 10);
    });
  }


  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


}
